import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import { ScreenTitleBar } from "@/components/navigation/ScreenTitleBar";
import { Text } from "@/components/ui/text";
import { FamilyProfilesSection } from "@/features/profile";
import { TEST_IDS } from "@/testIdDefinition";

export function FamilyScreen() {
    const { t } = useTranslation();

    return (
        <SafeAreaView className="flex-1 bg-background" edges={["top"]}>
            <ScreenTitleBar title={t("family.title")} />
            <ScrollView
                className="flex-1"
                contentContainerClassName="gap-6 px-4 pb-6"
                testID={TEST_IDS[TEST_IDS.FAMILY_SCREEN]}
            >
                <Text variant="caption">{t("family.subtitle")}</Text>
                <FamilyProfilesSection />
            </ScrollView>
        </SafeAreaView>
    );
}
